<div [class]="gridClass()">
  @for (input of inputs(); track $index) {
  <div [class]="input.class" [ngSwitch]="input.type">
    <app-input
      *ngSwitchCase="FormInputType.TEXT"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [label]="input.name"
      [mask]="input.mask"
      [email]="input.isEmail"
      [required]="input.required"
      [id]="input.formControlName"
    >
    </app-input>
     <div *ngSwitchCase="FormInputType.SELECT">
      @if(input.select; as select) {
      <app-select
        [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
        [label]="input.name"
        [items]="select | async"
        [required]="input.required"
        [multiple]="input.multiple"
        [errorMessage]="input.errorMessage"
        [id]="input.formControlName"
      >
      </app-select>
      }
    </div>
    <div *ngSwitchCase="FormInputType.RADIO">
      <label class="d-block"
        >{{ input.name | transloco }}
        <span *ngIf="input.required">*</span></label
      >
      <mat-radio-group
        [formControl]="$any(formGroupRef()?.controls[input.formControlName])"
      >
        <div *ngIf="input.radios?.length; else defaultBoolean">
          <mat-radio-button
            *ngFor="let radio of input.radios"
            color="primary"
            [value]="radio.value"
            [checked]="radio.checked"
          >
            {{ radio.name | transloco }}
          </mat-radio-button>
        </div>

        <ng-template #defaultBoolean>
          <mat-radio-button color="primary" [value]="true">
            {{ "yes" | transloco }}
          </mat-radio-button>
          <mat-radio-button color="primary" [value]="false">
            {{ "no" | transloco }}
          </mat-radio-button>
        </ng-template>
      </mat-radio-group>
    </div>
    <app-datepicker
      *ngSwitchCase="FormInputType.DATE"
      [label]="input.name"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [required]="input.required"
      [min]="input.minDate"
      [max]="input.maxDate"
    >
    </app-datepicker>
    <div *ngSwitchCase="FormInputType.CHECKBOX">
      <mat-checkbox
        color="primary"
        [formControl]="$any(formGroupRef()?.controls[input.formControlName])"
      >
        {{ input.name | transloco }}
      </mat-checkbox>
    </div>
    <app-input
      *ngSwitchCase="FormInputType.CPF"
      label="CPF"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [mask]="CPF_MASK"
      [placeholder]="CPF_MASK"
      [required]="input.required"
      cpfValidator
    >
      <ng-container slot="hint">
        <span
          *ngIf="formGroupRef()?.controls[input.formControlName].errors?.['invalidCpf']"
          class="c-status-error"
        >
          {{ "invalid-cpf" | transloco }}
        </span>
      </ng-container>
    </app-input>
    <app-input
      *ngSwitchCase="FormInputType.CNPJ"
      label="CNPJ"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [mask]="CNPJ_MASK"
      [placeholder]="CNPJ_MASK"
      [required]="input.required"
      cnpjValidator
      [id]="input.formControlName"
    >
      <ng-container slot="hint">
        <span
          *ngIf="formGroupRef()?.controls[input.formControlName].errors?.['invalidCpf']"
          class="c-status-error"
        >
          {{ "invalid-cnpj" | transloco }}
        </span>
      </ng-container>
    </app-input>
    <app-input-currency
      *ngSwitchCase="FormInputType.CURRENCY"
      [label]="input.name"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [required]="input.required"
    >
    </app-input-currency>
    <app-input
      *ngSwitchCase="FormInputType.NUMBER"
      [label]="input.name"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [required]="input.required"
      [mask]="input.mask"
      placeholder="Apenas Números"
      [type]="'number'"
    >
    </app-input>
    <app-input
      *ngSwitchCase="FormInputType.CEP"
      [label]="input.name"
      [formControlRef]="$any(formGroupRef()?.controls[input.formControlName])"
      [required]="input.required"
      cepValidator
      [mask]="CEP_MASK"
      [placeholder]="CEP_MASK"
    >
    </app-input>
    <div
      *ngSwitchCase="FormInputType.DIVISOR"
      class="s-mt-5 s-mb-5 border-bottom border-clr-platform-lightest"
    >
      <h3>{{ input.name }}</h3>
    </div>
    <div *ngSwitchCase="FormInputType.SUBDIVISOR" class="s-mt-5">
      <h4>{{ input.name }}</h4>
    </div>
  </div>
  }
</div>
